import { useEffect, useState } from "react";
import { Card, Spinner, Text } from "@fluentui/react-components";
import { app, pages } from "@microsoft/teams-js";

/**
 * Configuration page shown when the app is added to a meeting or group chat.
 * There is nothing for the user to configure — we register the save handler,
 * set a fixed content URL and immediately enable the Save button.
 */
export function ConfigPage() {
  const [ready, setReady] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        await app.initialize();
        pages.config.registerOnSaveHandler(async (saveEvent) => {
          try {
            await pages.config.setConfig({
              entityId: "meeting-angelo-lite-meeting",
              suggestedDisplayName: "Meeting Angelo",
              contentUrl: `${window.location.origin}/index.html#/meeting`,
              websiteUrl: `${window.location.origin}/index.html`,
            });
            saveEvent.notifySuccess();
          } catch (err) {
            saveEvent.notifyFailure(
              err instanceof Error ? err.message : "Failed to save configuration.",
            );
          }
        });
        await pages.config.setValidityState(true);
        app.notifySuccess();
        if (mounted) setReady(true);
      } catch (err) {
        if (mounted) {
          setError(err instanceof Error ? err.message : "Configuration failed to load.");
        }
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  if (error) {
    return (
      <Card style={{ padding: "1.5rem", margin: "1rem" }}>
        <Text weight="semibold" block>
          Something went wrong
        </Text>
        <Text size={200} block style={{ marginTop: "0.5rem" }}>
          {error}
        </Text>
      </Card>
    );
  }

  return (
    <Card style={{ padding: "1.5rem", margin: "1rem", textAlign: "center" }}>
      {!ready && <Spinner size="small" label="Preparing…" />}
      {ready && (
        <>
          <Text size={500} weight="semibold" block>
            Meeting Angelo Lite
          </Text>
          <Text block style={{ marginTop: "0.5rem", color: "var(--colorNeutralForeground2)" }}>
            Press <strong>Save</strong> and Meeting Angelo starts tracking this
            meeting automatically — no admin setup needed. Turn on transcription
            during the meeting and the AI summary appears in the meeting panel
            right after it ends.
          </Text>
        </>
      )}
    </Card>
  );
}
